export function initialize(appInstance) {
  const debugMenu = appInstance.lookup('service:debug/debug-menu');
  debugMenu.register('time-series.output', 'debug/time-series-output');
  debugMenu.register('contact', 'debug/contact');
}

export default {
  initialize,
};
